import { Spin } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { serverFetch } from "../../server";
import dayjs from "dayjs";
import "./sale.css";
import { useSelector } from "react-redux";
import { useWindowWidth } from "@react-hook/window-size";
import { PayButtons } from "../../controls";

const Sale = () => {
  const { code } = useParams();
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const company = useSelector((s) => s.company);
  const onlyWidth = useWindowWidth();
  
  const getData = () => {
    setLoading(true);
    setHasError(false);
    serverFetch(`order/${code}`)
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e.UserMessage);
        setItems([]);
        setLoading(false);
        setHasError(true);
      })
  }

  useEffect(getData, [code])

  let symaPlat = 0;
  let syma = 0;
  items.forEach(i => {
    if (!i.isDelete && !i.isPaid) symaPlat += i.totalPrice;
    syma += i.totalPrice;
  })

  const onPay = () => {

  }

  const DisablePayment = false;
  // const autopay = false;

  const divTotal = items.length && <div>
    {symaPlat > 0 && <div className="sale-item"><div>К оплате {symaPlat}</div>
      {company && <PayButtons 
        company={company}
        isMobile={onlyWidth < 700}
        onPay={onPay}
        disablePayment={DisablePayment}
        autopay={false}
        price={symaPlat}/>}
    </div>}
    {items[0].isPaid && <div className="sale-item"><div>Оплачено</div><div>{dayjs(items[0].paidOn).format("DD.MM.YYYY HH:mm")}</div><a href={items[0].paidUrl} target="_blank" rel="noreferrer">Чек</a></div>}
    {items[0].returnUrl && <div className="sale-item"><div>Возврат</div><a href={items[0].returnUrl} target="_blank" rel="noreferrer">Чек</a></div>}
  </div>

  return<div className='block-content'>
    {loading && <Spin />}
    {hasError && <div>ОШИБКА получения продажи</div>}
    {items.length && <div>
      <div className="sale-title"><div>Заказ {items[0].id}</div><div>Дата {dayjs(items.docDate).format("DD.MM.YYYY")}</div></div>
      <table className="tbl-sale">
        <thead>
        <tr><th /><th>Наименование</th><th>Цена</th><th>Количество</th><th>Комиссия</th><th>Сумма</th></tr>
        </thead>
        <tbody>
        {items.map((i,idx) => <tr key={i.id}>
          <td className="ac">{idx + 1}</td>
          <td>{i.name} {i.rentSize > 0 && ` - размер ${i.rentSize}`}</td>
          <td className="ar">{i.price}</td>
          <td className="ar">{i.qty}</td>
          <td className="ar">{i.commission}</td>
          <td className="ar">{i.totalPrice}</td>
        </tr>)}
        </tbody>
        <tfoot>
        <tr className="sale-total"><td colSpan={5} className="ar">Итого</td><td className="ar">{syma.toLocaleString()}</td></tr>
        </tfoot>
      </table>      
      {divTotal}
    </div>}
  </div>
}

export default Sale;